import { Language } from '@/types';

// Helper function to get language from localStorage
export const getStoredLanguage = (): Language => {
  try {
    const stored = localStorage.getItem('preferred-language');
    if (stored === Language.PT || stored === Language.EN) {
      return stored;
    }
  } catch (error) {
    console.warn(
      'Could not read language preference from localStorage:',
      error,
    );
  }
  return Language.EN; // Default fallback
};

// Helper function to save language to localStorage
export const saveLanguageToStorage = (language: Language) => {
  try {
    localStorage.setItem('preferred-language', language);
  } catch (error) {
    console.warn('Could not save language preference to localStorage:', error);
  }
};
